import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyPipe, formatDate } from '@angular/common';
import { CentralColumnDefinitionsService } from 'src/app/shared/services/central-column-definitions.service';
import { ManageRfpService } from '../manage-rfp.service';
import { Bom } from 'src/app/shared/model/bom.model';
import { Questioner } from 'src/app/core-module/rfp/questioner.model';
import { RfpDetails, UploadedFile } from '../rfp-list-detail/rfp-detail.model';
import { ItemPriceParameter, Priceparam } from '../rfp-list-detail/rfp-detail.model';
declare var require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-vendor-rfp-page',
  templateUrl: './vendor-rfp-page.component.html',
  styleUrls: ['./vendor-rfp-page.component.scss']
})
export class VendorRfpPageComponent implements OnInit, OnDestroy {
  private timer: any;
  public formattedHours: string = '00';
  public formattedMinutes: any = '00';
  public formattedSeconds: any = '00';
  difference!: number;
  fromDate!: any;
  loading: boolean = false;
  now: any;
  data: any = [];
  companyId!: any;
  vendorId!: any;
  rfpId!: any;
  rfpCat!: any;
  public rowData: any = [];
  public liveRfpData: any = [];
  private gridApi!: GridApi<any>;
  rowClass: string;
  startTime: any;
  endTime: any;
  vendorEmployees: any[] = [];
  productheader: any[] = [];
  bom: Bom = new Bom();
  itempriceparameter: ItemPriceParameter = new ItemPriceParameter();
  priceparam: Priceparam = new Priceparam();
  questioner: Questioner = new Questioner();
  fileDetails: any = { filePath: '', file: null };
  filename: any;
  rfpStartDate: any;
  rfpEndDate: any;
  dateDifference: any = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  formatedMinutes: any;
  formatedSeconds: any;
  ItemId: any;
  ItemCode: any;
  itemName: any;
  priceparamId: any;
  priceparamName: any;
  priceparamPrize: any;
  rfpCategory: any;
  item_id: any;
  vendorCode: string | undefined;
  vendor_id: string | undefined;
  rfpCode: string | undefined;
  PriceAmount: any[] = [];
  totalAmount: any;
  item: any;
  totalPrice: any;
  additional_charges: any;
  prCode: any;
  companyBranchId: any;
  endRfpTime: any;
  Document: any = [];
  total_Charges: any;
  totaChargesData: any;
  minDate = new Date();
  contact: RfpDetails = new RfpDetails();
  rfpFile: UploadedFile = new UploadedFile();
  DocsVendor: any = [];
  urlVendorId: any = null;
  urlCompanyId: any = null;

  @ViewChild('days', { static: true }) days?: ElementRef;
  @ViewChild('hours', { static: true }) hours?: ElementRef;
  @ViewChild('minutes', { static: true }) minutes?: ElementRef;
  @ViewChild('seconds', { static: true }) seconds?: ElementRef;
  months: Array<string> = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  constructor(
    private manageRfpService: ManageRfpService,
    private toastr: ToastrService,
    private router: Router,
    public columnDefsService: CentralColumnDefinitionsService,
    private activeRoute: ActivatedRoute,
    private currencyPipe: CurrencyPipe
  ) {
    this.rowClass = 'rowClass';
    // ✅ Read all query params – CRITICAL: use 'rfpCategory' (capital C) from URL
    this.activeRoute.queryParamMap.subscribe((param: any) => {
      this.rfpId = param.params.rfpid || param.params.rfpId;
      this.rfpCat = param.params.rfpCategory;   // ✅ FIXED – previously was 'rfpCat'
      this.urlVendorId = param.params.vendorId;
      this.urlCompanyId = param.params.companyId;
      this.rfpFile.vendorBiddingFiles = [''];
    });
  }

  ngOnInit(): void {
    this.bom.bomMapping = [{ assetCategories_id: 0, assetClass_id: 0, item_id: 0, quantity: 0, company_id: this.companyId }];

    // ✅ 1. Try to get logged‑in user details from localStorage
    const storedData = localStorage.getItem('user_details') ?? "{}";
    const userDetails = JSON.parse(storedData);

    // ✅ 2. Set vendorId and companyId – prefer logged‑in user, else use URL params
    if (userDetails && userDetails.company_id) {
      // User is logged in
      this.companyId = userDetails.company_id;
      this.vendorId = userDetails.vendor_id;
      this.contact.vendor_id = userDetails.vendor_id;
      this.contact.vendor_code = userDetails.vendorCode;
      this.contact.supplier_name = userDetails.supplierName;
      this.contact.supplierContactPerson_name = userDetails.supplierContactPersonName;
    } else if (this.urlVendorId) {
      // ✅ Not logged in – use values from URL
      this.vendorId = this.urlVendorId;
      this.contact.vendor_id = this.urlVendorId;
      this.companyId = this.urlCompanyId || null;
    } else {
      // ❌ No vendorId at all – show error and stop
      this.toastr.error('Vendor ID not found. Please use the correct link.');
      return;
    }

    // ✅ 3. Build the data object for the API call – including rfpCategory
    this.data = {
      company_id: this.companyId,
      rfp_id: this.rfpId,
      rfpCategory: this.rfpCat,   // ✅ now correctly populated from URL
      vendor_id: this.contact.vendor_id,
    };

    // ✅ 4. Call the API to fetch RFP details
    this.vendorRfpDetail();
    this.updateTimer();
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  onPageSizeChanged() {
    var value = (document.getElementById('page-size') as HTMLInputElement).value;
    this.gridApi.paginationSetPageSize(Number(value));
  }

  onFilterTextBoxChanged() {
    this.gridApi.setQuickFilter(
      (document.getElementById('filter-text-box') as HTMLInputElement).value
    );
  }

  addColumns(): void {
    const headersAndFields = [
      { headerName: 'Sr No.', field: '', valueGetter: 'node.rowIndex + 1' },
      { headerName: 'Company Name', field: 'tbl_company.company_name' },
      { headerName: 'RFP Type', field: 'rfpCategory' },
      { headerName: 'RFP Code', field: 'rfpCode' },
      { headerName: 'Start Date', field: 'rfpStartDate', cellRenderer: this.dateFormatter },
      { headerName: 'End Date', field: 'rfpEndDate', cellRenderer: this.dateFormatter },
    ];
    this.columnDefsService.generateColumns(headersAndFields);
  }

  onCellClicked(e: any) {
    if (e.colDef.field === "rfpCode") {
    }
  }

  filesend: any[] = [];
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const fileNameParts = file.name.split('.');
        const fileExtension = fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : '';
        this.filesend.push({
          file: e.target.result,
          fileExtension: fileExtension
        });
      };
      reader.readAsDataURL(file);
    }
  }

  onFileChange1(event: any, index: number) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const fileNameParts = file.name.split('.');
        const fileExtension = fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : '';
        if (fileExtension === 'pdf') {
          this.contact.vendorQuestionAnswer[index].file = e.target.result;
          this.contact.vendorQuestionAnswer[index].fileExtension = fileExtension;
        } else {
          this.toastr.error('Please upload only PDF files.', 'Invalid File Format');
          event.target.value = null;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Live': return '#ffffff';
      case 'Closed': return '#ffffff';
      default: return '';
    }
  }

  dateFormatter(params: any) {
    const formattedDate = formatDate(params.value, 'dd-MM-yyyy', 'en-US');
    return formattedDate;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

  add() {
    this.rfpFile.vendorBiddingFiles.push('');
  }

  remove(index: number) {
    this.rfpFile.vendorBiddingFiles.splice(index, 1);
  }

  rfpData: any;
  extraData: any;

 vendorRfpDetail() {
  this.manageRfpService.vendorRfpDetail(this.data).subscribe((res: any) => {
    this.rfpData = res.body.prData;
    const dt = res.body.data[0];
    this.rfpCategory = dt.rfpCategory;
    this.Document = res.body.data[0]?.tbl_rfpFileUploads;
    this.extraData = res.body.itemData;
    
    if (res && res.body && res.body.data) {
      this.liveRfpData = res.body.data[0];
      this.vendorEmployees = res.body.itemData;
      
      // ✅ CRITICAL FIX: Handle null end date
      // If end date is null, set a default (e.g., 7 days from start date)
      if (!this.liveRfpData.rfpEndDate) {
        const startDate = new Date(this.liveRfpData.rfpStartDate);
        // Set default end date to 7 days after start date
        const defaultEndDate = new Date(startDate);
        defaultEndDate.setDate(defaultEndDate.getDate() + 7);
        
        // Format as YYYY-MM-DD for consistency
        const year = defaultEndDate.getFullYear();
        const month = String(defaultEndDate.getMonth() + 1).padStart(2, '0');
        const day = String(defaultEndDate.getDate()).padStart(2, '0');
        this.liveRfpData.rfpEndDate = `${year}-${month}-${day}`;
        
        console.log('⚠️ RFP End Date was null, set default to:', this.liveRfpData.rfpEndDate);
      }
      
      if (res.body.data.tbl_rfpItemMappings != undefined) {
        this.contact.itemPriceParameter = res.body.data?.tbl_rfpItemMappings;
      } else {
        this.contact.itemPriceParameter = res.body.data?.tbl_rfpBOMMappings;
      }
      
      this.productheader = res.body.data[0].tbl_rfpPriceParamMappings;

      let rfpStartTime = this.liveRfpData.rfpStartTime;
      let timeParts = rfpStartTime.toString().split(':');
      let startHour = parseInt(timeParts[0], 10);
      let myTime = startHour >= 12 ? "PM" : "AM";

      let rfpEndTime = this.liveRfpData.rfpEndTime;
      if (rfpEndTime) {
        let timeParts1 = rfpEndTime.split(':');
        let endHour = parseInt(timeParts1[0], 10);
        let endMyTime = endHour >= 12 ? "PM" : "AM";
        this.endTime = endMyTime;
      }
      this.startTime = myTime;

      this.rfpStartDate = this.liveRfpData.rfpStartDate;
      this.rfpEndDate = this.liveRfpData.rfpEndDate;
      
      this.contact.vendorQuestionAnswer = res.body.questioner.map((res: any) => {
        return {
          question_id: res.questioner_id,
          correctAnswer: '',
          question: res.Question,
          weightage: '',
          answer: null,
          remark: '',
          questionType: res.questionType,
          mandatory: res.mandatory,
        };
      });
      
      this.getCreatedRfpDetails();
      this.calculateDateDifference();
      this.startCountdown();
      this.dateFormate();
    }
  });
}

  calculateItemTotal() {
    const sumOfCalculatedSums = this.vendorEmployees.reduce((acc, curr) => {
      const value = Number(curr.calculatedSum);
      return acc + (isNaN(value) ? 0 : value);
    }, 0);

    if (!isNaN(sumOfCalculatedSums)) {
      this.contact.total_charges = Math.round(sumOfCalculatedSums * 100) / 100;
      let sumOfCalculated = this.contact.total_charges.toFixed(2);
      if (this.contact.additional_charges) {
        let data = Number(sumOfCalculated) + this.contact.additional_charges;
        this.totaChargesData = data.toFixed(2);
      } else {
        this.totaChargesData = sumOfCalculated;
      }
      return this.totaChargesData;
    } else {
      let data = this.vendorEmployees.map(res => res.calculatedSum);
      return data.length > 0 ? data[0] : 0;
    }
  }

  calculateItemSum(item: any) {
    var sum = Number(item.pricePerItem) || 0;
    if (sum) {
      sum *= item.quantity;
    }
    let NewSum = sum;
    for (let i = 0; i < this.productheader.length; i++) {
      const header = this.productheader[i];
      if (header.priceParameterName === 'IGST' && (item.CGST || item.SGST)) {
        item.IGST = null;
      } else if ((header.priceParameterName === 'CGST' || header.priceParameterName === 'SGST') && item.IGST) {
        item.CGST = null;
        item.SGST = null;
      }
      const value = Number(item[header.priceParameterName]) || 0;
      if (value == 0) {
        sum += value;
      } else if (header.priceParameterName == 'additional_charges') {
        sum += value;
      } else {
        let newtotal = NewSum * (value / 100);
        sum += newtotal;
      }
    }
    let amount = Math.round(sum * 100) / 100;
    item.calculatedSum = amount;
  }

  generatePriceParams(item: any) {
    return this.productheader.map(priceParam => ({
      priceParam_id: priceParam.priceParameter_id.toString(),
      priceParam_name: priceParam.priceParameterName,
      priceParam_prize: item[priceParam.priceParameterName],
    }));
  }

  submit() {
    let allDocumentsProvided = true;
    this.loading = true;
    for (let i = 0; i < this.contact.vendorQuestionAnswer.length; i++) {
      if (this.contact.vendorQuestionAnswer[i].mandatory === true) {
        if (!this.contact.vendorQuestionAnswer[i]?.file) {
          this.toastr.error('Document is required!!');
          allDocumentsProvided = false;
          this.loading = false;
          break;
        }
      }
    }

    if (!allDocumentsProvided) {
      return;
    }

    const itemPriceParameter = this.vendorEmployees?.map(item => {
      this.calculateItemSum(item);
      const priceParams = this.generatePriceParams(item);
      return {
        item_id: item.item_id,
        item_code: item.itemCode,
        item_name: item.itemName,
        itemAmount: item.calculatedSum,
        uom_id: this.extraData[0].uom_id,
        uomName: this.extraData[0].uomName,
        service_id: item.service_id,
        serviceName: item.serviceName,
        serviceCode: "fgffg54",
        mVP: this.extraData[0].mVP,
        vendor_id: this.contact.vendor_id,
        vendorCode: this.contact.vendor_code,
        supplierName: this.contact.supplier_name,
        supplierContactPersonName: this.contact.supplierContactPerson_name,
        mailId: "amit@gmail.com",
        prCategoryStatus: this.rfpData[0]?.prCategoryStatus,
        totalAmount: this.rfpData[0]?.totalAmount,
        finalTotalAmount: this.rfpData[0]?.finalTotalAmount,
        vendorAmount: "400",
        company_id: this.companyId,
        prType: this.rfpData[0]?.prType,
        price_param: priceParams,
        pricePerItem: item.pricePerItem
      };
    });

    const payload = {
      itemPriceParameter: itemPriceParameter,
      company_id: this.companyId,
      rfp_id: this.rfpId,
      rfp_code: this.liveRfpData.rfpCode,
      vendor_id: this.contact.vendor_id,
      vendor_code: this.contact.vendor_code,
      vendorBiddingFiles: this.filesend,
      lead_time: this.contact.lead_time,
      credit_days: this.contact.credit_days,
      additional_charges: this.contact.additional_charges,
      remark: this.contact.remark,
      total_charges: this.calculateItemTotal(),
      vendorQuestionAnswer: this.contact.vendorQuestionAnswer,
      vendorInterest: 'Interested'
    };

    this.manageRfpService.rfpdetailCreate(payload).subscribe(
      (res: any) => {
        if (res) {
          this.toastr.success(res.body.message);
          this.loading = false;
          this.router.navigate(['vendor/manage-rfp/live']);
        }
      },
      (error) => {
        this.loading = false;
        console.error(error);
        this.toastr.error('Something went wrong. Please try again.');
      }
    );
  }

  resetItem() {
    this.contact = new RfpDetails();
  }

  addRow() {
    this.contact.technicalDetails?.push({ technicalQuestion: '', points: 0, weightage: 0, vendorValue: 0 });
  }

  removeRow(index: number) {
    this.bom.bomMapping?.splice(index, 1);
  }

  addRow1() {
    this.questioner.questionerMapping?.push({ correctAnswer: '', question: '', weightage: '' });
  }

  removeRow1(index: number) {
    this.questioner.questionerMapping?.splice(index, 1);
  }

  onFileSelected(fileInput: File[] | any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const file = fileInput.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fileDetails.filePath = e.target.result;
      };
      reader.readAsDataURL(file);
      this.fileDetails.file = file;
    } else {
      this.fileDetails = { filePath: '', file: null };
    }
    this.filename = this.fileDetails.file.name;
  }

  downloadContact(e: any) {
    if (this.contact?.rfp_FileUpload) {
      const pdfUrl = this.contact.rfp_FileUpload;
      const pdfName = this.contact.rfp_FileUpload;
      FileSaver.saveAs(pdfUrl, pdfName);
    }
  }

calculateDateDifference(): void {
  if (!this.liveRfpData) {
    console.warn('⚠️ liveRfpData is not available');
    return;
  }

  // ✅ Check if rfpEndDate exists and is not null
  if (!this.liveRfpData.rfpEndDate) {
    console.warn('⚠️ rfpEndDate is null or undefined, cannot calculate difference');
    // Set default values or show "N/A"
    this.dateDifference.days = 0;
    this.dateDifference.hours = 0;
    this.dateDifference.minutes = 0;
    this.dateDifference.seconds = 0;
    
    // Update timer display
    if (this.days) this.days.nativeElement.innerText = '0';
    if (this.hours) this.hours.nativeElement.innerText = '00';
    if (this.minutes) this.minutes.nativeElement.innerText = '00';
    if (this.seconds) this.seconds.nativeElement.innerText = '00';
    return;
  }

  // ✅ Parse the end date with time
  let rfpEndDate = this.liveRfpData.rfpEndDate;
  let rfpEndTime = this.liveRfpData.rfpEndTime || '23:59'; // Default to end of day if time is missing
  
  // ✅ Handle date format (assuming YYYY-MM-DD)
  let dateParts = rfpEndDate.split('-');
  if (dateParts.length !== 3) {
    console.warn('⚠️ Invalid date format:', rfpEndDate);
    return;
  }
  
  let timeParts = rfpEndTime.split(':');
  let year = parseInt(dateParts[0], 10);
  let month = parseInt(dateParts[1], 10) - 1;
  let day = parseInt(dateParts[2], 10);
  let hour = parseInt(timeParts[0], 10);
  let minute = parseInt(timeParts[1], 10) || 0;
  
  let rfpEndDateTime = new Date(year, month, day, hour, minute);
  const now = new Date();
  const difference = rfpEndDateTime.getTime() - now.getTime();

  if (difference > 0) {
    this.dateDifference.days = Math.floor(difference / (1000 * 60 * 60 * 24));
    this.dateDifference.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.dateDifference.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    this.dateDifference.seconds = Math.floor((difference % (1000 * 60)) / 1000);
  } else {
    this.dateDifference.days = 0;
    this.dateDifference.hours = 0;
    this.dateDifference.minutes = 0;
    this.dateDifference.seconds = 0;
    clearInterval(this.timer);
  }
}

  private updateTimer(): void {
    const hours = Math.floor(this.timerSeconds / 3600);
    const minutes = Math.floor((this.timerSeconds % 3600) / 60);
    const seconds = this.timerSeconds % 60;
    this.formattedHours = `${this.padWithZero(hours)}`;
    this.formatedMinutes = `${this.padWithZero(minutes)}`;
    this.formatedSeconds = `${this.padWithZero(seconds)}`;
    this.timerSeconds--;
  }

  private padWithZero(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  private timerSeconds: number = 0;

  startCountdown(): void {
    this.timer = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown(): void {
    this.calculateDateDifference();
    if (this.liveRfpData && this.liveRfpData.rfpEndDate) {
      if (this.days) {
        this.days.nativeElement.innerText = this.dateDifference.days.toString();
      }
      if (this.hours) {
        this.hours.nativeElement.innerText = this.padWithZero(this.dateDifference.hours);
      }
      if (this.minutes) {
        this.minutes.nativeElement.innerText = this.padWithZero(this.dateDifference.minutes);
      }
      if (this.seconds) {
        this.seconds.nativeElement.innerText = this.padWithZero(this.dateDifference.seconds);
      }
    }
  }

  currentTime: any;
  targetDate: any;
  targetTime: any;

dateFormate() {
  if (!this.rfpEndDate) {
    console.warn('⚠️ rfpEndDate is null, using fallback');
    this.currentTime = 'End date not available';
    return;
  }
  
  try {
    this.targetDate = new Date(this.rfpEndDate);
    this.targetTime = this.targetDate.getTime();
    this.currentTime = `${this.months[this.targetDate.getMonth()]} ${this.targetDate.getDate()}, ${this.targetDate.getFullYear()}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    this.currentTime = 'Invalid date';
  }
}
  vendorStatus(event: any): void {
    let data = {
      rfp_id: this.rfpId,
      vendor_id: this.vendorId,
      vendorInterest: event
    };
    this.manageRfpService.updatevendorInterest(data).subscribe((res: any) => {
      location.reload();
      this.toastr.success('vendor Not Interested Successfully', '', { timeOut: 2000 });
      this.router.navigate(['/vendor/manage-rfp/live']);
    }, (err: any) => {});
  }

  getCreatedRfpDetails() {
    this.manageRfpService.getCreatedRfpDetails(this.rfpId, this.vendorId).subscribe((res: any) => {
      if (res.body.data) {
        this.rfpFile.vendorBiddingFiles = res.body.data?.documents;
        this.total_Charges = res.body.data?.leadData?.total_charges;
        this.contact.lead_time = res.body.data?.leadData?.lead_time;
        this.contact.credit_days = res.body.data?.leadData?.credit_days;
        this.contact.remark = res.body.data?.leadData?.remark;
        this.contact.vendorQuestionAnswer = res.body.data?.technicalQuestions.map((res: any) => {
          return {
            question_id: res.questioner_id,
            correctAnswer: '',
            question: res.Question,
            weightage: '',
            answer: res.answer,
            remark: res.remark,
            questionType: res.questionType,
            mandatory: res.mandatory,
            document: res.document
          };
        });
        const flattenedData = res.body.data.itemsWithGst.reduce((acc: any, curr: any) => acc.concat(curr), []);
        this.vendorEmployees.forEach(item => {
          const matchedData = flattenedData.find((resItem: any) => resItem.item_id == item.item_id);
          if (matchedData && matchedData.priceParams) {
            item.pricePerItem = matchedData.pricePerItem;
            item.itemAmount = matchedData.itemAmount;
            for (let i = 0; i < matchedData.priceParams.length; i++) {
              if (matchedData.priceParams[i].priceParam_name == "CGST") {
                item.CGST = matchedData.priceParams[i].priceParam_prize;
              } else if (matchedData.priceParams[i].priceParam_name == "SGST") {
                item.SGST = matchedData.priceParams[i].priceParam_prize;
              } else if (matchedData.priceParams[i].priceParam_name == "IGST") {
                item.IGST = matchedData.priceParams[i].priceParam_prize;
              } else {
                item["additional_charges"] = matchedData.priceParams[i].priceParam_prize;
              }
            }
          }
        });
      }
    }, (err: any) => {});
  }

  getCurrencyDisplay(item: any): string {
    const symbol = this.currencyPipe.transform(1, item.currency_code, 'symbol', '1.0-0')?.slice(0, 1);
    return `${symbol}`;
  }
}